"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var util_1 = require("@aperza/util");
var ui_1 = require("@aperza/ui");
exports.useCatalogItemListener = function (className) {
    if (className === void 0) { className = 'catalogPreview'; }
    var _a = react_1.useState(undefined), catalog = _a[0], setCatalog = _a[1];
    var getMessage = ui_1.useReactiveMessage('CATALOG_PREVIEW').getMessage;
    var subscription;
    var onClickPreview = function (event) {
        var source = event.currentTarget;
        console.log('useCatalogItemListener.onClickPreview');
        console.log(source);
        if (source) {
            var parent_1 = source.parentElement;
            if ($(parent_1).hasClass('m_previewBtn')) {
                parent_1 = parent_1.parentElement;
            }
            var superParent = parent_1.parentElement;
            var previewEl = $(superParent);
            var title = previewEl.find('.catalogTitleLink').text().trim();
            var subtitle = previewEl.find('[name="catalogSubtitle"]').val();
            var description = previewEl.find('[name="catalogDescription"]').val();
            var type = previewEl.find('[name="catalogDocumentTypeLabel"]').val();
            var brandName = previewEl.find('.catalogCompanyLink').text().trim();
            var brandImageUrl = previewEl.find('[name=catalogCompanyLogoUrl]').val();
            var fileSize = previewEl.find('[name="catalogDocumentSizeBytes"]').val();
            var catalogPageUrl = previewEl.find('[name="catalogPageUrl"]').val();
            var pages = [];
            for (var i = 1; i <= 3; i++) {
                var catalogImage = previewEl.find("[name=\"catalogImage" + i + "\"]").val();
                if (catalogImage) {
                    pages.push({ imageUrl: catalogImage });
                }
            }
            var downloadButtonEl = $(superParent).find('.catalogDownloadLink')[0];
            setCatalog({
                title: title,
                subtitle: subtitle,
                description: description,
                type: type,
                brandName: brandName,
                brandImageUrl: brandImageUrl,
                fileSize: fileSize,
                catalogPageUrl: catalogPageUrl,
                pages: pages,
                companyId: parseInt(downloadButtonEl.dataset.company_id),
                catalogId: parseInt(downloadButtonEl.dataset.catalog_id),
                companyContractDisplayId: parseInt(downloadButtonEl.dataset.company_contract_display_id),
                documentId: downloadButtonEl.dataset.document_id,
                clickedAt: new Date().getTime(),
            });
        }
    };
    react_1.useEffect(function () {
        subscription = getMessage().subscribe(function (message) {
            if (message) {
                setCatalog({
                    requestId: util_1.UUIDUtil.uuid(),
                    title: message.title,
                    subtitle: message.subtitle,
                    description: message.description,
                    type: message.tags.length > 0 ? message.tags[0] : '',
                    brandName: message.companyName,
                    brandImageUrl: message.companyLogoUrl,
                    //companyPageUrl: message.companyPageUrl,
                    fileSize: '' + message.fileSize,
                    makerItemCompanyUrl: message.makerItemCompanyUrl,
                    makerItemCompanyName: message.makerItemCompanyName,
                    makerItemCompanyLogoUrl: message.makerItemCompanyLogoUrl,
                    documentPreviewUrl: message.documentPreviewUrl,
                    documentPublishFlag: message.documentPublishFlag,
                    isSharedDocument: message.isSharedDocument,
                    isReferencedDocument: message.isReferencedDocument,
                    itemCompanyContractDisplayId: message.itemCompanyContractDisplayId,
                    documentDisplayId: message.documentDisplayId,
                    documentType: message.documentType,
                    makerItemCompanyContractDisplayId: message.makerItemCompanyContractDisplayId,
                    makerItemDocumentDisplayId: message.makerItemDocumentDisplayId,
                    cluezCategoryIdPath: message.cluezCategoryIdPath,
                    userId: message.userId,
                    companyName: message.companyName,
                    catalogPageUrl: message.catalogPageUrl,
                    pages: message.catalogPreviewImageUrls.map(function (url) {
                        return { imageUrl: url };
                    }),
                    companyId: message.companyId,
                    catalogId: message.catalogId,
                    companyContractDisplayId: message.companyContractDisplayId,
                    designType: message.designType,
                    clickedAt: new Date().getTime(),
                });
            }
        });
        var elements = document.getElementsByClassName(className);
        Array.from(elements).forEach(function (el) {
            el.addEventListener('click', function (event) {
                if (event)
                    onClickPreview(event);
            });
        });
    }, []);
    return { catalog: catalog };
};
